import type { SignedRequest, TranslateRequestParams, GetTokenFunction } from '../types';

export class TokenManager {
  private getToken: GetTokenFunction;

  constructor(getToken: GetTokenFunction) {
    this.getToken = getToken;
  }

  async getSignedRequest(params: TranslateRequestParams): Promise<SignedRequest> {
    return this.getToken(params);
  }
}
